import {
  createOrganization
} from "./chunk-MJWTRZ63.js";

// src/organization/emptyState.tsx
import { Avatar } from "@lb-lib/ui";
import { EmptyState } from "@loopbound-ares/components";
import { useUser } from "@loopbound-ares/state";
import { jsx } from "react/jsx-runtime";
var WorkspaceEmptyState = ({
  description
}) => {
  let user = useUser();
  return /* @__PURE__ */ jsx(EmptyState, { icon: /* @__PURE__ */ jsx(Avatar, { entity: user.data, size: 40 }), title: `Nice to meet you, ${user.data?.name}`, description, actions: [{
    children: "Create an organization",
    onClick: () => createOrganization()
  }] });
};

// src/organization/members/index.ts
import { dynamicComponent } from "@lb-lib/dynamic-component";
var OrganizationInvitesScene = dynamicComponent(async () => (await import("./invites-6ML6AGK7.js")).OrganizationInvitesScene);
var OrganizationMembersScene = dynamicComponent(async () => (await import("./members-JMIWIV3W.js")).OrganizationMembersScene);

// src/organization/security/index.ts
import { dynamicComponent as dynamicComponent2 } from "@lb-lib/dynamic-component";
var OrganizationAuditLogScene = dynamicComponent2(async () => (await import("./audit-logs-H5GC7LSH.js")).OrganizationAuditLogScene);
var OrganizationSSOScene = dynamicComponent2(async () => (await import("./sso-I5C5T4YC.js")).OrganizationSSOScene);

// src/organization/workspaces/index.ts
import { dynamicComponent as dynamicComponent3 } from "@lb-lib/dynamic-component";
var OrganizationWorkspacesScene = dynamicComponent3(async () => (await import("./overview-H5Y5SV6R.js")).OrganizationWorkspacesScene);
var OrganizationWorkspaceScene = dynamicComponent3(async () => (await import("./overview-JH4RWBVP.js")).OrganizationWorkspaceScene);

// src/organization/index.ts
import { dynamicComponent as dynamicComponent4, dynamicFunction } from "@lb-lib/dynamic-component";
import { memo } from "@lb-lib/memo";
var OrganizationAlertsScene = dynamicComponent4(async () => (await import("./alerts-IZNQOQIF.js")).OrganizationAlertsScene);
var OrganizationBillingScene = dynamicComponent4(async () => (await import("./billing-AINGDQ5I.js")).OrganizationBillingScene);
var OrganizationGeneralScene = dynamicComponent4(async () => (await import("./general-SYBWTA4R.js")).OrganizationGeneralScene);
var OrgMemberReference = dynamicComponent4(async () => (await import("./orgMemberReference-BNAYX7W3.js")).OrgMemberReference);
var createFetcher = memo(() => import("./create-GRQNR7QC.js"));
var CreateOrganization = dynamicComponent4(async () => (await createFetcher()).CreateOrganization);
var createOrganization2 = dynamicFunction(async () => (await createFetcher()).createOrganization);

export {
  WorkspaceEmptyState,
  OrganizationInvitesScene,
  OrganizationMembersScene,
  OrganizationAuditLogScene,
  OrganizationSSOScene,
  OrganizationWorkspacesScene,
  OrganizationWorkspaceScene,
  OrganizationAlertsScene,
  OrganizationBillingScene,
  OrganizationGeneralScene,
  OrgMemberReference,
  CreateOrganization,
  createOrganization2 as createOrganization
};
//# sourceMappingURL=chunk-YOANETQR.js.map